// The landing page's capture demo. Each sample is a note a rep might write
// after a meeting, and the draft ActiveOptics would propose from it: the
// activity, the people, the next steps and, when the account is new to the
// CRM, the account. Pre-written so the public page makes no AI call, costs
// nothing and touches no real record. Every name here is fictional.

export const DEMO_SAMPLES = [
  {
    key: 'meeting',
    label: 'Customer meeting',
    note:
      'Met Priya Shah (director of engineering) and Tom Becker (buyer) at Northwind Optical. ' +
      'They are qualifying an 800G module for a cloud customer and need samples within two weeks. ' +
      'Priya wants our thermal data before their design review. Tom asked for pricing at 50k units a year. ' +
      'Follow up with both next Tuesday.',
    draft: {
      account: { name: 'Northwind Optical', isNew: false },
      activity: {
        type: 'Meeting',
        summary: 'Northwind is qualifying an 800G module for a cloud customer. Samples needed within two weeks; thermal data needed before their design review; pricing requested at 50k units a year.',
      },
      contacts: [
        { name: 'Priya Shah', title: 'Director of Engineering', isNew: true },
        { name: 'Tom Becker', title: 'Buyer', isNew: true },
      ],
      actionItems: [
        { title: 'Send thermal data to Priya', due: 'This Friday' },
        { title: 'Quote 50k units a year to Tom', due: 'In 3 days' },
        { title: 'Ship 800G samples', due: 'In 2 weeks' },
        { title: 'Follow-up call with Priya and Tom', due: 'Next Tuesday' },
      ],
    },
  },
  {
    key: 'rep',
    label: 'Rep firm call',
    note:
      'Call with Marco Ruiz at Summit Rep Group. He hears Cascade Networks may move their 400G line to a second source next year. ' +
      'He wants a joint visit to Cascade in early December. I owe him the updated line card.',
    draft: {
      account: { name: 'Cascade Networks', isNew: false },
      activity: {
        type: 'Call',
        summary: 'Summit Rep Group reports Cascade may second-source its 400G line next year. Marco Ruiz proposes a joint visit to Cascade in early December.',
      },
      contacts: [
        { name: 'Marco Ruiz', title: 'Principal, Summit Rep Group', isNew: false },
      ],
      actionItems: [
        { title: 'Send Marco the updated line card', due: 'Tomorrow' },
        { title: 'Plan a joint visit to Cascade with Summit', due: 'Early December' },
      ],
    },
  },
  {
    key: 'show',
    label: 'Trade show lead',
    note:
      'Booth visit: Elena Vasquez, CTO of Brightwave Photonics, a startup building silicon photonics engines. ' +
      'Interested in our evaluation kit. Send kit details and set up an intro call with our field engineer.',
    draft: {
      account: { name: 'Brightwave Photonics', isNew: true },
      activity: {
        type: 'Trade show',
        summary: 'Brightwave Photonics (silicon photonics engines) is interested in the evaluation kit. Intro call with a field engineer requested.',
      },
      contacts: [
        { name: 'Elena Vasquez', title: 'CTO', isNew: true },
      ],
      actionItems: [
        { title: 'Send evaluation kit details to Elena', due: 'Tomorrow' },
        { title: 'Set up intro call with our field engineer', due: 'This week' },
      ],
    },
  },
];

// The Today preview: the real section names, sample rows.
export const TODAY_SAMPLE = [
  { section: 'Overdue', tone: 'danger', rows: [{ title: 'Send 800G samples to Northwind', meta: '2 days late' }] },
  { section: 'Due today', tone: 'warning', rows: [{ title: 'Quote 50k units to Tom Becker', meta: 'Northwind Optical' }] },
  { section: 'Quiet accounts', tone: 'ai', rows: [{ title: 'Cascade Networks', meta: 'No activity in 24 days, $420k open' }] },
  { section: 'Past close date', tone: 'warning', rows: [{ title: 'Brightwave 1.6T evaluation', meta: '7 days past, Proposal' }] },
];

// The Executive Review preview: the same account told to two audiences.
export const REVIEW_SAMPLE = {
  account: 'Northwind Optical',
  status: 'On track',
  internal: [
    '800G samples ship in two weeks for a cloud qualification.',
    'Pricing at 50k units a year is with the buyer.',
    'Risk: their design review needs our thermal data first.',
  ],
  customer: [
    '800G samples ship in two weeks to support your qualification.',
    'Thermal data will reach your engineering team ahead of the design review.',
    'Joint follow-up call set for next week.',
  ],
};
